module.exports = __webpack_public_path__ + "img/142.75a06d6c.jpg";